// extracted by mini-css-extract-plugin
export default {"accessibleLiveMessage":"AccessibleLiveMessage_accessibleLiveMessage__-Zw0i"};